import * as React from 'react';
import { copyTextToClipboard } from '../../../utils.js'

export default function TextCopyable(props) {
	const {
		icon,
		text,
		value
	} = props;
	return (
		<span
			className="text-copy"
			onClick={(e) => copyTextToClipboard(e, value)}
		>
			{icon}{text}
		</span>
	);
}